// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Container,
//   Typography,
//   Button,
//   Stack,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   TextField
// } from "@mui/material";
// import AICapabilitiesSlider from "./AICapabilitiesSlider";
// import Header1 from "../Header/Header4";
// import Footer3 from "../Footer/Footer3";
// import IndustriesSlider from "./IndustriesSlider";
// import axios from "axios";
// import { useAuth } from "../../AuthContext";

// const API_URL = process.env.REACT_APP_API_URL;

// const EnterpriseAISolutions = () => {
//   const { userId } = useAuth();

//   const [openDialog, setOpenDialog] = useState(false);
//   const [requireContact, setRequireContact] = useState(false);
//   const [contact, setContact] = useState("");
//   const [query, setQuery] = useState("");

//    useEffect(() => {
//           window.scrollTo(0, 0);  // Scroll to top when this page is loaded
//       }, []);


//   useEffect(() => {
//   if (!userId) return;

//   const trackVisit = async () => {
//     try {
//       await axios.post(
//         `${API_URL}/enterprise-ai/visit/`,
//         { user_id: userId }
//       );
//     } catch (err) {
//       console.error("Visit tracking failed", err);
//     }
//   };

//   trackVisit();
// }, [userId]);


//   // Scroll to AI Capabilities
//   const scrollToCapabilities = () => {
//     document
//       .getElementById("ai-capabilities")
//       ?.scrollIntoView({ behavior: "smooth" });
//   };

//   // Open CTA dialog
//   const handleOpenDialog = () => {
//     if (!userId) {
//       alert("Please login to continue");
//       return;
//     }
//     setOpenDialog(true);
//   };

//   // Submit interest
//   const handleSubmit = async () => {
//     try {
//       const res = await axios.post(
//         `${API_URL}/enterprise-ai/interest/`,
//         {
//           user_id: userId,
//           contact,
//           query
//         }
//       );

//       if (res.data.require_contact) {
//         setRequireContact(true);
//         return;
//       }

//       setOpenDialog(false);
//       setContact("");
//       setQuery("");
//       setRequireContact(false);

//       alert("Thanks! Our AI experts will contact you shortly 🚀");
//     } catch (err) {
//       console.error(err);
//       alert("Something went wrong. Please try again.");
//     }
//   };

//   return (
//     <div>
//       <Header1 />

//       <Box sx={{ mt: -2 }}>
//         {/* HERO */}
//         <Box
//           sx={{
//             minHeight: "90vh",
//             display: "flex",
//             alignItems: "center",
//             background:
//               "radial-gradient(circle at top, #1e3a8a, #020617)",
//             color: "white"
//           }}
//         >
//           <Container>
//             <Typography
//               variant="h2"
//               fontWeight={800}
//               gutterBottom
//               sx={{ maxWidth: 800 }}
//             >
//               Enterprise AI, Designed for Real-World Impact
//             </Typography>

//             <Typography
//               variant="h6"
//               sx={{ opacity: 0.85, maxWidth: 700, mb: 4 }}
//             >
//               We build secure, scalable, and intelligent AI systems that help
//               enterprises, governments, and educational institutions innovate
//               faster and operate smarter.
//             </Typography>

//             <Stack direction="row" spacing={2}>
//               <Button
//                 size="large"
//                 variant="contained"
//                 color="secondary"
//                 onClick={handleOpenDialog}
//               >
//                 Talk to Experts
//               </Button>

//               <Button
//                 size="large"
//                 variant="outlined"
//                 sx={{ color: "white", borderColor: "white" }}
//                 onClick={scrollToCapabilities}
//               >
//                 View Capabilities
//               </Button>
//             </Stack>
//           </Container>
//         </Box>

//         {/* AI CAPABILITIES */}
//         <div id="ai-capabilities">
//           <AICapabilitiesSlider />
//         </div>

//         <IndustriesSlider />

//         {/* CTA */}
//         <Box
//           sx={{
//             py: 10,
//             background: "radial-gradient(circle at top, #020617, #000000)",
//             color: "white",
//             textAlign: "center"
//           }}
//         >
//           <Container maxWidth="md">
//             <Typography variant="h3" fontWeight={800} gutterBottom>
//               Ready to Build the Future with AI?
//             </Typography>

//             <Typography sx={{ opacity: 0.85, mb: 4 }}>
//               Whether you’re an enterprise, government agency, or educational
//               institution, we help you turn AI ambition into execution.
//             </Typography>

//             <Button
//               size="large"
//               variant="contained"
//               color="secondary"
//               onClick={handleOpenDialog}
//             >
//               Start Your AI Journey
//             </Button>
//           </Container>
//         </Box>
//       </Box>

//      {/* CONTACT / QUERY DIALOG */}
// <Dialog
//   open={openDialog}
//   onClose={() => setOpenDialog(false)}
//   maxWidth="sm"
//   fullWidth
//   PaperProps={{
//     sx: {
//       borderRadius: 4,
//       background:
//         "linear-gradient(180deg, #020617 0%, #020617 60%, #020617 100%)",
//       color: "white",
//       boxShadow: "0 20px 60px rgba(0,0,0,0.6)"
//     }
//   }}
// >
//   {/* HEADER */}
//   <Box
//     sx={{
//       px: 4,
//       py: 3,
//       borderBottom: "1px solid rgba(255,255,255,0.08)"
//     }}
//   >
//     <Typography variant="h5" fontWeight={800}>
//       🚀 Talk to AI Experts
//     </Typography>
//     <Typography sx={{ opacity: 0.75, mt: 0.5 }}>
//       Tell us what you’re building — we’ll help you design it right.
//     </Typography>
//   </Box>

//   {/* CONTENT */}
//   <DialogContent sx={{ px: 4, py: 3 }}>
//     <Stack spacing={3}>
//       {requireContact && (
//         <TextField
//           label="Contact Number"
//           placeholder="e.g. +1 987 654 3210"
//           fullWidth
//           required
//           value={contact}
//           onChange={(e) => setContact(e.target.value)}
//           InputLabelProps={{ style: { color: "#c7d2fe" } }}
//           InputProps={{
//             sx: {
//               borderRadius: 2,
//               backgroundColor: "#020617",
//               color: "white"
//             }
//           }}
//         />
//       )}

//       <TextField
//         label="How can we help you?"
//         placeholder="Describe your AI use case, challenge, or idea…"
//         multiline
//         rows={4}
//         fullWidth
//         required
//         value={query}
//         onChange={(e) => setQuery(e.target.value)}
//         InputLabelProps={{ style: { color: "#c7d2fe" } }}
//         InputProps={{
//           sx: {
//             borderRadius: 2,
//             backgroundColor: "#020617",
//             color: "white"
//           }
//         }}
//       />

//       {/* CTA */}
//       <Button
//         variant="contained"
//         size="large"
//         onClick={handleSubmit}
//         sx={{
//           mt: 1,
//           py: 1.5,
//           fontWeight: 700,
//           borderRadius: 2,
//           background:
//             "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
//           boxShadow: "0 10px 30px rgba(99,102,241,0.5)",
//           textTransform: "none",
//           fontSize: "1rem",
//           "&:hover": {
//             background:
//               "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)"
//           }
//         }}
//       >
//         Request Expert Consultation
//       </Button>

//       {/* FOOTNOTE */}
//       <Typography
//         variant="caption"
//         sx={{ opacity: 0.6, textAlign: "center" }}
//       >
//         🔒 Your information is secure and will never be shared.
//       </Typography>
//     </Stack>
//   </DialogContent>
// </Dialog>


//       <Footer3 />
//     </div>
//   );
// };

// export default EnterpriseAISolutions;


/**
 * EnterpriseHero.jsx
 * Premium, responsive hero section — React + MUI + Framer Motion
 * Drop-in replacement. Requires:
 *   npm install framer-motion   (if not already installed)
 *   @mui/material + @emotion/react + @emotion/styled
 *
 * Props:
 *   onTalkToExperts  — callback for primary CTA
 *   onViewCapabilities — callback / scroll for secondary CTA
 */

// import { useState, useEffect } from "react";
// import { Box, Button, Container, Stack, Typography } from "@mui/material";
// import { motion, AnimatePresence } from "framer-motion";
// import Header1 from "../Header/Header1";
// import TrustedBy from "./TrustedBy";
// import IndustriesSlider from "./IndustriesSlider";
// import OurSolutions from "./OurSolutions";
// import Footer2 from "../Footer/Footer2";

// /* ─── Font import (Bricolage Grotesque — distinctive, editorial weight) ──── */
// const FontImport = () => (
//   <style>{`
//     @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,200..800&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500&display=swap');
//   `}</style>
// );

// /* ─── Rotating words ─────────────────────────────────────────────────────── */
// const WORDS = ["Voice Agents", "Multilingual AI", "RAG Systems"];
// const WORD_INTERVAL = 3000; // ms per word

// /* ─── Motion variants ────────────────────────────────────────────────────── */
// const wordVariants = {
//   enter: { opacity: 0, y: 20, filter: "blur(6px)" },
//   visible: {
//     opacity: 1,
//     y: 0,
//     filter: "blur(0px)",
//     transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
//   },
//   exit: {
//     opacity: 0,
//     y: -16,
//     filter: "blur(4px)",
//     transition: { duration: 0.38, ease: [0.55, 0, 0.78, 0] },
//   },
// };

// const fadeUp = (delay = 0) => ({
//   initial: { opacity: 0, y: 24 },
//   animate: { opacity: 1, y: 0, transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] } },
// });

// /* ─── Animated orb (reusable) ────────────────────────────────────────────── */
// const Orb = ({ sx }) => (
//   <Box
//     component={motion.div}
//     animate={{ scale: [1, 1.08, 1], opacity: [0.7, 1, 0.7] }}
//     transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
//     sx={{
//       position: "absolute",
//       borderRadius: "50%",
//       pointerEvents: "none",
//       ...sx,
//     }}
//   />
// );

// /* ─── Main component ─────────────────────────────────────────────────────── */
// export default function EnterpriseHero({
//   onTalkToExperts,
//   onViewCapabilities,
// }) {
//   const [wordIndex, setWordIndex] = useState(0);

//   useEffect(() => {
//     const id = setInterval(
//       () => setWordIndex((i) => (i + 1) % WORDS.length),
//       WORD_INTERVAL
//     );
//     return () => clearInterval(id);
//   }, []);

//   const Counter = ({ end, suffix = "+" }) => {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     let start = 0;

//     const duration = 1800;
//     const increment = end / (duration / 16);

//     const timer = setInterval(() => {
//       start += increment;

//       if (start >= end) {
//         setCount(end);
//         clearInterval(timer);
//       } else {
//         setCount(Math.floor(start));
//       }
//     }, 16);

//     return () => clearInterval(timer);
//   }, [end]);

//   return (
//     <>
//       {count}
//       {suffix}
//     </>
//   );
// };

//   return (
//     <>
//       <FontImport />
//        <Header1></Header1>
//       <Box
//         component="section"
//         sx={{
//           position: "relative",
//           minHeight: "100svh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           overflow: "hidden",
//           /* ── Background ── */
//           backgroundColor: "#000000",
          
//           color: "white",
//           fontFamily: "'Bricolage Grotesque', sans-serif",
//         }}
//       >
//         {/* ── Subtle grid ── */}
//         <Box
//           aria-hidden
//           sx={{
//             position: "absolute",
//             inset: 0,
//             backgroundImage:
//               "linear-gradient(rgba(255,255,255,0.028) 1px, transparent 1px)," +
//               "linear-gradient(90deg, rgba(255,255,255,0.028) 1px, transparent 1px)",
//             backgroundSize: "56px 56px",
//             maskImage:
//               "radial-gradient(ellipse 70% 70% at 50% 50%, black 0%, transparent 100%)",
//             pointerEvents: "none",
//           }}
//         />

//         {/* ── Orbs ── */}
//         <Orb
//           sx={{
//             top: "-12%",
//             right: "-8%",
//             width: { xs: 340, md: 560 },
//             height: { xs: 340, md: 560 },
//             background:
// "radial-gradient(circle, rgba(30,144,255,0.14) 0%, transparent 72%)",
//             filter: "blur(40px)",
//           }}
//         />
//         <Orb
//           sx={{
//             bottom: "-18%",
//             left: "-10%",
//             width: { xs: 280, md: 480 },
//             height: { xs: 280, md: 480 },
//            background:
// "radial-gradient(circle, rgba(0,119,255,0.08) 0%, transparent 72%)",
//             filter: "blur(60px)",
//           }}
//         />

//         {/* ── Thin accent beam — top centre ── */}
//         <Box
//           aria-hidden
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: "50%",
//             transform: "translateX(-50%)",
//             width: "1px",
//             height: { xs: "30%", md: "40%" },
//             color: "#1E90FF",
//             pointerEvents: "none",
//           }}
//         />

//         {/* ═══════════════════════════ CONTENT ═══════════════════════════ */}
//         <Container
//           maxWidth="lg"
//           sx={{
//             position: "relative",
//             zIndex: 2,
//             px: { xs: 3, sm: 4, md: 6 },
//             py: { xs: 14, sm: 16, md: 0 },
//           }}
//         >
//           <Box
//             sx={{
//               maxWidth: { xs: "100%", sm: 680, md: 860 },
//               mx: "auto",
//               textAlign: "center",
//             }}
//           >
//             {/* ── Badge ── */}
//             <motion.div {...fadeUp(0.1)}>
//               <Box
//                 sx={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   gap: 1.2,
//                   px: 2,
//                   py: 0.75,
//                   mb: { xs: 5, md: 6 },
//                   borderRadius: "999px",
//                   background: "rgba(255,255,255,0.04)",
//                   border: "1px solid rgba(255,255,255,0.09)",
//                   backdropFilter: "blur(16px)",
//                 }}
//               >
//                 {/* Pulse dot */}
//                 <Box sx={{ position: "relative", width: 8, height: 8, flexShrink: 0 }}>
//                   <Box
//                     component={motion.div}
//                     animate={{ scale: [1, 2], opacity: [0.6, 0] }}
//                     transition={{ duration: 1.6, repeat: Infinity, ease: "easeOut" }}
//                     sx={{
//                       position: "absolute",
//                       inset: 0,
//                       borderRadius: "50%",
//                       background: "#1E90FF",
//                     }}
//                   />
//                   <Box
//                     sx={{
//                       width: 8,
//                       height: 8,
//                       borderRadius: "50%",
//                       background: "#1E90FF",
//                       boxShadow: "0 0 10px #1E90FF",
//                     }}
//                   />
//                 </Box>

//                 <Typography
//                   sx={{
//                     fontFamily: "'DM Sans', sans-serif",
//                     fontSize: { xs: "0.75rem", sm: "0.82rem" },
//                     color: "rgba(255,255,255,0.65)",
//                     fontWeight: 500,
//                     letterSpacing: "0.02em",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Enterprise AI&nbsp;·&nbsp;Agentic Systems&nbsp;·&nbsp;Real‑Time Intelligence
//                 </Typography>
//               </Box>
//             </motion.div>

//             {/* ── Headline block ── */}
//             <motion.div {...fadeUp(0.22)}>
//               <Typography
//                 component="h1"
//                 sx={{
//                   fontFamily: "'Bricolage Grotesque', sans-serif",
//                   fontWeight: 750,
//                   letterSpacing: { xs: "-1.5px", md: "-3px" },
//                   lineHeight: { xs: 1.08, md: 1.04 },
//                   color: "rgba(255,255,255,0.95)",
//                   /*
//                    * clamp() gives perfectly fluid sizing:
//                    *  - 2.6rem @ ~320px
//                    *  - 5.2rem @ ~1280px
//                    */
//                   fontSize: {
//                     xs: "2.6rem",
//                     sm: "3.6rem",
//                     md: "4.8rem",
//                     lg: "5.6rem",
//                   },
//                   mb: 0,
//                 }}
//               >
//                 Building Enterprise AI
//                 <br />
//                 <Box
//                   component="span"
//                   sx={{
//                     background: "#1E90FF",
                   
//                     WebkitBackgroundClip: "text",
//                     WebkitTextFillColor: "transparent",
//                     backgroundClip: "text",
//                   }}
//                 >
//                   For Real‑World
//                 </Box>
//               </Typography>
//             </motion.div>

//             {/* ── Animated rotating word ── */}
//             <motion.div {...fadeUp(0.28)}>
//               <Box
//                 sx={{
//                   mt: { xs: 0.5, md: 0.5 },
//                   /*
//                    * Fixed height = line‑height of the rotating text.
//                    * Prevents layout shift when words change.
//                    */
//                   height: { xs: "52px", sm: "68px", md: "84px", lg: "96px" },
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   overflow: "visible",
//                   position: "relative",
//                 }}
//               >
//                 <AnimatePresence mode="wait">
//                   <motion.span
//                     key={wordIndex}
//                     variants={wordVariants}
//                     initial="enter"
//                     animate="visible"
//                     exit="exit"
//                     style={{
//                       position: "absolute",
//                       display: "block",
//                       fontFamily: "'Bricolage Grotesque', sans-serif",
//                       fontWeight: 750,
//                       letterSpacing: "-2px",
//                       lineHeight: 1,
//                       background: "#1E90FF",
                     
//                       WebkitBackgroundClip: "text",
//                       WebkitTextFillColor: "transparent",
//                       backgroundClip: "text",
//                       /* Match h1 sizing */
//                       fontSize: "clamp(2.4rem, 6vw, 5.6rem)",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     {WORDS[wordIndex]}
//                   </motion.span>
//                 </AnimatePresence>
//               </Box>
//             </motion.div>

//             {/* ── Subtitle ── */}
//             <motion.div {...fadeUp(0.38)}>
//               <Typography
//                 sx={{
//                   fontFamily: "'DM Sans', sans-serif",
//                   mt: { xs: 4, md: 5 },
//                   mx: "auto",
//                   maxWidth: { xs: "100%", sm: "580px", md: "660px" },
//                   fontSize: { xs: "0.95rem", sm: "1rem", md: "1.08rem" },
//                   lineHeight: 1.85,
//                   color: "rgba(255,255,255,0.52)",
//                   fontWeight: 400,
//                 }}
//               >
//                 From sovereign AI infrastructure and multilingual LLM systems to
//                 voice agents, RAG architectures, multimodal AI, and real‑time enterprise
//                 automation — we design intelligent systems built for scale, security,
//                 and real‑world deployment.
//               </Typography>
//             </motion.div>

//             {/* ── CTAs ── */}
//             <motion.div {...fadeUp(0.5)}>
//               <Stack
//                 direction={{ xs: "column", sm: "row" }}
//                 spacing={{ xs: 1.5, sm: 2 }}
//                 justifyContent="center"
//                 alignItems="center"
//                 sx={{ mt: { xs: 5, md: 6 } }}
//               >
//                 {/* Primary */}
//                 <Button
//                   variant="contained"
//                   size="large"
//                   onClick={onTalkToExperts}
//                   component={motion.button}
//                   whileHover={{ scale: 1.03, boxShadow: "0 20px 50px rgba(0,255,163,0.35)" }}
//                   whileTap={{ scale: 0.97 }}
//                   sx={{
//                     px: { xs: 4, md: 4.5 },
//                     py: 1.6,
//                     borderRadius: "14px",
//                     textTransform: "none",
//                     fontFamily: "'DM Sans', sans-serif",
//                     fontWeight: 600,
//                     fontSize: { xs: "0.92rem", md: "0.98rem" },
//                     background:  "#1E90FF",
                    
//                     color: "#00140D",
//                     boxShadow: "0 12px 32px rgba(0,255,163,0.22), 0 0 0 1px rgba(0,255,163,0.15)",
//                     letterSpacing: "0.01em",
//                     transition: "box-shadow 0.25s ease",
//                     width: { xs: "100%", sm: "auto" },
//                     maxWidth: { xs: 320, sm: "none" },
//                     "&:hover": {
//                       background: "linear-gradient(135deg, #33ffb5 0%, #00da88 100%)",
//                     },
//                   }}
//                 >
//                   Talk to Experts
//                 </Button>

//                 {/* Secondary */}
//                 <Button
//                   variant="outlined"
//                   size="large"
//                   onClick={onViewCapabilities}
//                   component={motion.button}
//                   whileHover={{ scale: 1.03 }}
//                   whileTap={{ scale: 0.97 }}
//                   sx={{
//                     px: { xs: 4, md: 4.5 },
//                     py: 1.6,
//                     borderRadius: "14px",
//                     textTransform: "none",
//                     fontFamily: "'DM Sans', sans-serif",
//                     fontWeight: 600,
//                     fontSize: { xs: "0.92rem", md: "0.98rem" },
//                     border: "1px solid rgba(255,255,255,0.11)",
//                     color: "rgba(255,255,255,0.82)",
//                     background: "rgba(255,255,255,0.04)",
//                     backdropFilter: "blur(12px)",
//                     letterSpacing: "0.01em",
//                     transition: "border-color 0.25s ease, background 0.25s ease",
//                     width: { xs: "100%", sm: "auto" },
//                     maxWidth: { xs: 320, sm: "none" },
//                     "&:hover": {
//                       border: "1px solid rgba(0,255,163,0.35)",
//                       background: "rgba(0,255,163,0.05)",
//                       color: "#ffffff",
//                     },
//                   }}
//                 >
//                   View Capabilities
//                 </Button>
//               </Stack>
//             </motion.div>

//             {/* ── Subtle social proof strip ── */}
//            {/* ── Animated Stats Tiles ── */}
// <motion.div {...fadeUp(0.62)}>
//   <Stack
//     direction={{ xs: "column", sm: "row" }}
//     spacing={{ xs: 2, md: 3 }}
//     justifyContent="center"
//     alignItems="center"
//     sx={{
//       mt: { xs: 7, md: 9 },
//     }}
//   >
//     {[
//       {
//         value: "40+",
//         label: "Enterprise Deployments",
//       },
//       {
//         value: "25+",
//         label: "Languages Supported",
//       },
//       {
//         value: "12+",
//         label: "AI Models Integrated",
//       },
//     ].map((item, i) => (
//       <Box
//         key={item.label}
//         component={motion.div}
//         initial={{ opacity: 0, y: 30 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{
//           duration: 0.6,
//           delay: i * 0.12,
//           ease: [0.22, 1, 0.36, 1],
//         }}
//         whileHover={{
//           y: -8,
//           scale: 1.03,
//         }}
//         sx={{
//           position: "relative",
//           overflow: "hidden",
//           minWidth: { xs: "100%", sm: 220 },
//           maxWidth: { xs: 320, sm: 240 },
//           px: 4,
//           py: 3.2,
//           borderRadius: "24px",
//           background:
//             "linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.03))",
//           border: "1px solid rgba(255,255,255,0.08)",
//           backdropFilter: "blur(20px)",
//           boxShadow:
//             "0 10px 40px rgba(0,0,0,0.35)",
//           transition: "all 0.3s ease",
//         }}
//       >
//         {/* Glow */}
//         <Box
//           component={motion.div}
//           animate={{
//             opacity: [0.4, 0.8, 0.4],
//             scale: [1, 1.08, 1],
//           }}
//           transition={{
//             duration: 4,
//             repeat: Infinity,
//             ease: "easeInOut",
//           }}
//           sx={{
//             position: "absolute",
//             width: 140,
//             height: 140,
//             borderRadius: "50%",
//             background:
//               "radial-gradient(circle, rgba(0,255,163,0.16), transparent 70%)",
//             top: -50,
//             right: -50,
//             filter: "blur(20px)",
//           }}
//         />

//         {/* Animated Number */}
//         <Typography
//           component={motion.h3}
//           animate={{
//             y: [0, -3, 0],
//           }}
//           transition={{
//             duration: 3,
//             repeat: Infinity,
//             ease: "easeInOut",
//           }}
//           sx={{
//             position: "relative",
//             zIndex: 2,
//             fontFamily:
//               "'Bricolage Grotesque', sans-serif",
//             fontWeight: 800,
//             fontSize: {
//               xs: "2.3rem",
//               md: "2.8rem",
//             },
//             lineHeight: 1,
//             background:
//               "linear-gradient(135deg,#A855F7,#B8FFE7)",
//             WebkitBackgroundClip: "text",
//             WebkitTextFillColor: "transparent",
//             mb: 1,
//           }}
//         >
//           <Counter end={parseInt(item.value)} />
//         </Typography>

//         {/* Label */}
//         <Typography
//           sx={{
//             position: "relative",
//             zIndex: 2,
//             fontFamily: "'DM Sans', sans-serif",
//             fontSize: "0.82rem",
//             color: "rgba(255,255,255,0.52)",
//             letterSpacing: "0.05em",
//             textTransform: "uppercase",
//             fontWeight: 500,
//             lineHeight: 1.6,
//           }}
//         >
//           {item.label}
//         </Typography>
//       </Box>
//     ))}
//   </Stack>
// </motion.div>
//           </Box>
//         </Container>

//         {/* ── Bottom fade-out vignette ── */}
//         <Box
//           aria-hidden
//           sx={{
//             position: "absolute",
//             bottom: 0,
//             left: 0,
//             right: 0,
//             height: "160px",
//             background:
//               "linear-gradient(to top, #020403 0%, transparent 100%)",
//             pointerEvents: "none",
//           }}
//         />
//       </Box>
//       <TrustedBy/>
//         <IndustriesSlider/>
//        <OurSolutions/>   
//        <Footer2 />
//     </>
//   );
// }




// import { useState, useEffect } from "react";
// import {
//   Box,
//   Button,
//   Container,
//   Stack,
//   Typography,
//   Dialog,
//   DialogContent,
//   TextField,
//   IconButton,
//   CircularProgress,
//   Alert,
//   Collapse,
// } from "@mui/material";
// import { motion, AnimatePresence } from "framer-motion";
// import axios from "axios";

// import Header1            from "../Header/Header1";
// import TrustedBy          from "./TrustedBy";
// import IndustriesSlider   from "./IndustriesSlider";
// import OurSolutions       from "./OurSolutions";
// import Footer             from "../Footer/Footer";
// import NewsLetterSection  from "./NewsLetterSection";
// import RecognizedBy       from "./RecognisedBy";
// import HomeBlogSection     from "./HomeBlogSection";
// import RequestAuditSection from "./Audit";

// // ─────────────────────────────────────────────────────────────────────────────
// // CONFIG
// // ─────────────────────────────────────────────────────────────────────────────
// const API_URL       = process.env.REACT_APP_API_URL || "";
// const WORDS         = ["Voice Agents", "Multilingual AI", "RAG Systems"];
// const WORD_INTERVAL = 3000;

// const rng = (s) => { const x = Math.sin(s + 1) * 10000; return x - Math.floor(x); };

// const PARTICLES = Array.from({ length: 55 }, (_, i) => ({
//   id:      i,
//   x:       rng(i * 3.14159) * 100,
//   y:       rng(i * 2.71828) * 100,
//   size:    rng(i * 1.41421) * 2.4 + 0.7,
//   opacity: rng(i * 1.61803) * 0.18 + 0.04,
//   durY:    rng(i * 5.55)    * 20  + 14,
//   durX:    rng(i * 7.77)    * 16  + 10,
//   dy:     (rng(i * 4.44)   - 0.5) * 50,
//   dx:     (rng(i * 6.66)   - 0.5) * 30,
//   isBlue:  rng(i * 9.99)    > 0.48,
//   dlyY:    rng(i * 2.22)   * -25,
//   dlyX:    rng(i * 3.33)   * -18,
// }));

// const NEURAL_PATHS = [
//   { d: "M-200 155 C50 85  280 225 530 155 T980  155 T1430 155 T1950 155",   sw: 0.55, dur: 26, dly: 0    },
//   { d: "M-200 455 C120 375 380 535 680 455 T1130 455 T1580 455 T1950 455",  sw: 0.70, dur: 32, dly: -10  },
//   { d: "M-200 760 C80  688 310 832 580 760 T1030 760 T1480 760 T1950 760",  sw: 0.50, dur: 21, dly: -17  },
//   { d: "M-80  0   C120 200 300 480 440 680 S560  850 590  1000",             sw: 0.55, dur: 28, dly: -5   },
//   { d: "M1940 0   C1740 200 1560 480 1420 680 S1300 850 1270 1000",         sw: 0.55, dur: 28, dly: -14  },
//   { d: "M-80  1000 C210 780 460 480 660 280 S810  80  900 -60",             sw: 0.50, dur: 23, dly: -9   },
//   { d: "M390  -60 C368 170 438 380 470 545 S478 725 428 910",               sw: 0.50, dur: 19, dly: -7   },
//   { d: "M970  -60 C948 200 1008 425 985 585 S965 765 1028 960",             sw: 0.50, dur: 24, dly: -12  },
//   { d: "M1490 -60 C1468 155 1530 365 1506 528 S1486 708 1548 905",          sw: 0.48, dur: 22, dly: -18  },
//   { d: "M140  315 C275 215 478 215 608 315 S738  415 690 500",              sw: 0.60, dur: 17, dly: -4   },
//   { d: "M1010 215 C1130 115 1330 115 1450 215 S1570 315 1528 418",          sw: 0.60, dur: 18, dly: -11  },
//   { d: "M440  558 C598 458 798 638 1000 558 S1202 458 1360 558",            sw: 0.55, dur: 22, dly: -15  },
// ];

// const SIGNAL_PATHS = [
//   { idx: 1,  dur: 10, dly: 0,  rev: false },
//   { idx: 4,  dur: 13, dly: -4, rev: true  },
//   { idx: 9,  dur:  9, dly: -2, rev: false },
//   { idx: 11, dur: 12, dly: -7, rev: true  },
// ];

// const NEURAL_NODES = [
//   { cx: 530,  cy: 155, r: 2.2 }, { cx: 980,  cy: 155, r: 1.8 },
//   { cx: 680,  cy: 455, r: 2.6 }, { cx: 1130, cy: 455, r: 2.0 },
//   { cx: 390,  cy: 545, r: 1.8 }, { cx: 800,  cy: 680, r: 2.2 },
//   { cx: 1200, cy: 295, r: 1.8 }, { cx: 340,  cy: 275, r: 2.0 },
//   { cx: 1410, cy: 578, r: 2.2 }, { cx: 605,  cy: 760, r: 1.8 },
//   { cx: 1058, cy: 760, r: 2.0 }, { cx: 195,  cy: 598, r: 1.8 },
// ];

// // ─────────────────────────────────────────────────────────────────────────────
// // GLOBAL STYLES
// // ─────────────────────────────────────────────────────────────────────────────
// const Styles = () => (
//   <style>{`
//     @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,400;12..96,600;12..96,750;12..96,800&family=DM+Sans:wght@300;400;500;600&display=swap');

//     @keyframes neuralPulse {
//       0%,100% { opacity: var(--np, .08); }
//       50%     { opacity: calc(var(--np, .08) * 2.1); }
//     }
//     @keyframes signalFwd { from { stroke-dashoffset:  2700; } to { stroke-dashoffset: -2700; } }
//     @keyframes signalRev { from { stroke-dashoffset: -2700; } to { stroke-dashoffset:  2700; } }
//     @keyframes scanUp {
//       0%   { transform: translateY(102vh); opacity: 0;   }
//       4%   { opacity: 1;   }
//       94%  { opacity: 0.7; }
//       100% { transform: translateY(-4px);  opacity: 0;   }
//     }
//     @keyframes cardGlow {
//       0%,100% { opacity: .5; transform: scale(1);    }
//       50%     { opacity: .9; transform: scale(1.12); }
//     }
//     .np { animation: neuralPulse 8s ease-in-out infinite; }

//     /* Dialog field styles */
//     .expert-field .MuiOutlinedInput-root {
//       background: rgba(255,255,255,0.04);
//       border-radius: 12px;
//       font-family: 'DM Sans', sans-serif;
//       color: rgba(255,255,255,0.88);
//       transition: background 0.2s;
//     }
//     .expert-field .MuiOutlinedInput-root:hover { background: rgba(30,144,255,0.05); }
//     .expert-field .MuiOutlinedInput-root.Mui-focused { background: rgba(30,144,255,0.07); }
//     .expert-field .MuiOutlinedInput-notchedOutline { border-color: rgba(255,255,255,0.1) !important; transition: border-color 0.2s; }
//     .expert-field .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline { border-color: rgba(30,144,255,0.35) !important; }
//     .expert-field .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline { border-color: rgba(30,144,255,0.7) !important; border-width: 1.5px !important; }
//     .expert-field .MuiInputLabel-root { font-family: 'DM Sans', sans-serif; color: rgba(255,255,255,0.38); font-size: 0.9rem; }
//     .expert-field .MuiInputLabel-root.Mui-focused { color: rgba(30,144,255,0.9); }
//     .expert-field .MuiInputBase-input { font-size: 0.93rem; }
//     .expert-field .MuiFormHelperText-root { font-family: 'DM Sans', sans-serif; font-size: 0.76rem; color: rgba(255,80,80,0.85); }
// }

// @media (max-height: 860px) {
//   .hero-badge    { margin-bottom: 20px !important; }
//   .hero-word-box { height: 54px !important; }
//   .hero-subtitle { margin-top: 18px !important; }
//   .hero-cta      { margin-top: 26px !important; }
//   .hero-stats    { margin-top: 28px !important; }
//   .hero-stats > div { padding-top: 16px !important; padding-bottom: 16px !important; }
// }

// @media (max-height: 680px) {
//   .hero-subtitle { display: none; }
// }
//   `}</style>
// );

// // ─────────────────────────────────────────────────────────────────────────────
// // MOTION HELPERS
// // ─────────────────────────────────────────────────────────────────────────────
// const wordVariants = {
//   enter:   { opacity: 0, y: 22,  filter: "blur(7px)"  },
//   visible: { opacity: 1, y: 0,   filter: "blur(0px)",
//              transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
//   exit:    { opacity: 0, y: -18, filter: "blur(4px)",
//              transition: { duration: 0.38, ease: [0.55, 0, 0.78, 0] } },
// };

// const fadeUp = (delay = 0) => ({
//   initial: { opacity: 0, y: 26 },
//   animate: { opacity: 1, y: 0,
//              transition: { duration: 0.72, delay, ease: [0.22, 1, 0.36, 1] } },
// });

// // ─────────────────────────────────────────────────────────────────────────────
// // BACKGROUND COMPONENTS  (unchanged logic, same visuals)
// // ─────────────────────────────────────────────────────────────────────────────
// const NeuralBackground = () => (
//   <Box aria-hidden sx={{ position: "absolute", inset: 0, overflow: "hidden", pointerEvents: "none", zIndex: 0 }}>
//     <svg viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid slice"
//          style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}>
//       {NEURAL_PATHS.map((p, i) => (
//         <path key={`base-${i}`} className="np" d={p.d} fill="none"
//               stroke="rgba(30,144,255,1)" strokeWidth={p.sw}
//               style={{ "--np": 0.07 + (i % 3) * 0.02, animationDuration: `${p.dur}s`, animationDelay: `${p.dly}s` }} />
//       ))}
//       {SIGNAL_PATHS.map((sp, i) => (
//         <path key={`sig-${i}`} d={NEURAL_PATHS[sp.idx].d} fill="none"
//               stroke="rgba(96,165,250,0.55)" strokeWidth="1.4" strokeLinecap="round"
//               strokeDasharray="65 2700"
//               style={{ animation: `${sp.rev ? "signalRev" : "signalFwd"} ${sp.dur}s linear infinite`, animationDelay: `${sp.dly}s` }} />
//       ))}
//       {NEURAL_NODES.map((n, i) => (
//         <motion.circle key={`node-${i}`} cx={n.cx} cy={n.cy}
//                        fill="rgba(30,144,255,0.25)" stroke="rgba(96,165,250,0.3)" strokeWidth="0.8"
//                        animate={{ r: [n.r, n.r + 2.8, n.r], opacity: [0.22, 0.52, 0.22] }}
//                        transition={{ duration: 3.2 + i * 0.35, repeat: Infinity, ease: "easeInOut", delay: -(i * 0.42) }} />
//       ))}
//     </svg>
//   </Box>
// );

// const AmbientGlow = () => (
//   <Box aria-hidden sx={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 0 }}>
//     <Box component={motion.div}
//          animate={{ scale: [1, 1.18, 1], opacity: [0.45, 0.75, 0.45] }}
//          transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
//          sx={{ position: "absolute", top: "-18%", right: "-12%",
//                width: { xs: 280, sm: 380, md: 580, xl: 700 },
//                height: { xs: 280, sm: 380, md: 580, xl: 700 },
//                borderRadius: "50%",
//                background: "radial-gradient(circle, rgba(30,144,255,0.11) 0%, transparent 70%)",
//                filter: "blur(45px)" }} />
//     <Box component={motion.div}
//          animate={{ scale: [1, 1.12, 1], opacity: [0.35, 0.6, 0.35] }}
//          transition={{ duration: 11, repeat: Infinity, ease: "easeInOut", delay: -3.5 }}
//          sx={{ position: "absolute", bottom: "-22%", left: "-12%",
//                width: { xs: 220, sm: 320, md: 480, xl: 580 },
//                height: { xs: 220, sm: 320, md: 480, xl: 580 },
//                borderRadius: "50%",
//                background: "radial-gradient(circle, rgba(30,144,255,0.08) 0%, transparent 70%)",
//                filter: "blur(60px)" }} />
//     <Box component={motion.div}
//          animate={{ opacity: [0.12, 0.24, 0.12] }}
//          transition={{ duration: 7, repeat: Infinity, ease: "easeInOut", delay: -2 }}
//          sx={{ position: "absolute", top: "15%", left: "50%", transform: "translateX(-50%)",
//                width: { xs: 340, sm: 520, md: 820, xl: 1100 },
//                height: { xs: 140, sm: 220, md: 320, xl: 400 },
//                borderRadius: "50%",
//                background: "radial-gradient(ellipse, rgba(30,144,255,0.07) 0%, transparent 70%)",
//                filter: "blur(55px)" }} />
//   </Box>
// );

// const ScanLines = () => (
//   <Box aria-hidden sx={{ position: "absolute", inset: 0, overflow: "hidden", pointerEvents: "none", zIndex: 1 }}>
//     {[{ op: 0.055, dur: 24, dly: 0 }, { op: 0.04, dur: 30, dly: -9 }, { op: 0.03, dur: 38, dly: -18 }]
//       .map((s, i) => (
//         <Box key={i} sx={{
//           position: "absolute", left: 0, right: 0, height: "1px",
//           background: `linear-gradient(90deg, transparent 0%, rgba(30,144,255,${s.op * 2}) 20%, rgba(96,165,250,${s.op}) 50%, rgba(30,144,255,${s.op * 2}) 80%, transparent 100%)`,
//           animation: `scanUp ${s.dur}s linear infinite`,
//           animationDelay: `${s.dly}s`,
//         }} />
//       ))}
//   </Box>
// );

// const ParticleField = () => (
//   <Box aria-hidden sx={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 1, overflow: "hidden" }}>
//     {PARTICLES.map((p) => (
//       <Box key={p.id} component={motion.div}
//            animate={{ y: [0, p.dy, 0], x: [0, p.dx, 0] }}
//            transition={{
//              y: { duration: p.durY, repeat: Infinity, ease: "easeInOut", delay: p.dlyY },
//              x: { duration: p.durX, repeat: Infinity, ease: "easeInOut", delay: p.dlyX },
//            }}
//            sx={{
//              position: "absolute", left: `${p.x}%`, top: `${p.y}%`,
//              width: `${p.size}px`, height: `${p.size}px`, borderRadius: "50%",
//              background: p.isBlue ? `rgba(30,144,255,${p.opacity * 3})` : `rgba(255,255,255,${p.opacity})`,
//              boxShadow: p.isBlue && p.size > 2 ? `0 0 ${p.size * 3}px rgba(30,144,255,0.5)` : "none",
//              willChange: "transform",
//            }} />
//     ))}
//   </Box>
// );

// // ─────────────────────────────────────────────────────────────────────────────
// // COUNTER
// // ─────────────────────────────────────────────────────────────────────────────
// const Counter = ({ end, suffix = "+" }) => {
//   const [count, setCount] = useState(0);
//   useEffect(() => {
//     let cur = 0;
//     const step = end / (1800 / 16);
//     const timer = setInterval(() => {
//       cur += step;
//       if (cur >= end) { setCount(end); clearInterval(timer); }
//       else setCount(Math.floor(cur));
//     }, 16);
//     return () => clearInterval(timer);
//   }, [end]);
//   return <>{count}{suffix}</>;
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // CLOSE ICON
// // ─────────────────────────────────────────────────────────────────────────────
// const CloseIcon = () => (
//   <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
//     <line x1="1" y1="1" x2="17" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//     <line x1="17" y1="1" x2="1" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//   </svg>
// );

// // ─────────────────────────────────────────────────────────────────────────────
// // TALK TO EXPERTS DIALOG
// // ─────────────────────────────────────────────────────────────────────────────
// const INITIAL_FORM   = { name: "", email: "", contact: "", purpose: "" };
// const INITIAL_ERRORS = { name: "", email: "", contact: "", purpose: "" };

// function TalkToExpertsDialog({ open, onClose }) {
//   const [form,     setForm]     = useState(INITIAL_FORM);
//   const [errors,   setErrors]   = useState(INITIAL_ERRORS);
//   const [loading,  setLoading]  = useState(false);
//   const [success,  setSuccess]  = useState(false);
//   const [apiError, setApiError] = useState("");

//   useEffect(() => {
//     if (open) {
//       setForm(INITIAL_FORM); setErrors(INITIAL_ERRORS);
//       setLoading(false); setSuccess(false); setApiError("");
//     }
//   }, [open]);

//   const validate = () => {
//     const errs = { ...INITIAL_ERRORS }; let valid = true;
//     if (!form.name.trim())                                          { errs.name    = "Name is required";              valid = false; }
//     if (!form.email.trim())                                         { errs.email   = "Email is required";             valid = false; }
//     else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))      { errs.email   = "Enter a valid email";            valid = false; }
//     if (!form.contact.trim())                                       { errs.contact = "Contact number is required";   valid = false; }
//     else if (!/^\+?[\d\s\-().]{7,20}$/.test(form.contact))        { errs.contact = "Enter a valid number";          valid = false; }
//     if (!form.purpose.trim())                                       { errs.purpose = "Please describe your purpose"; valid = false; }
//     setErrors(errs); return valid;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm(prev => ({ ...prev, [name]: value }));
//     if (errors[name])  setErrors(prev  => ({ ...prev, [name]: "" }));
//     if (apiError)      setApiError("");
//   };

//   const handleSubmit = async () => {
//     if (!validate()) return;
//     setLoading(true); setApiError("");
//     try {
//       await axios.post(`${API_URL}/expert/contact/`, {
//         name: form.name.trim(), email: form.email.trim(),
//         contact: form.contact.trim(), purpose: form.purpose.trim(),
//       });
//       setSuccess(true);
//       setTimeout(() => onClose(), 2800);
//     } catch (err) {
//       setApiError(
//         err?.response?.data?.error ||
//         err?.response?.data?.detail ||
//         err?.response?.data?.message ||
//         "Something went wrong. Please try again."
//       );
//     } finally { setLoading(false); }
//   };

//   const panelVariants = {
//     hidden:  { opacity: 0, y: 40, scale: 0.96 },
//     visible: { opacity: 1, y: 0,  scale: 1,    transition: { duration: 0.42, ease: [0.22, 1, 0.36, 1] } },
//     exit:    { opacity: 0, y: 24, scale: 0.97, transition: { duration: 0.26, ease: [0.55, 0, 0.78, 0] } },
//   };

//   const fieldSx = {
//     mb: 0,
//     "& .MuiOutlinedInput-root": {
//       background: "rgba(255,255,255,0.04)", borderRadius: "12px",
//       fontFamily: "'DM Sans', sans-serif", color: "rgba(255,255,255,0.88)", transition: "background 0.2s",
//       "&:hover": { background: "rgba(30,144,255,0.05)" },
//       "&.Mui-focused": { background: "rgba(30,144,255,0.07)" },
//     },
//     "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,0.1)", transition: "border-color 0.2s" },
//     "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(30,144,255,0.35)" },
//     "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(30,144,255,0.7)", borderWidth: "1.5px" },
//     "& .MuiInputLabel-root": { fontFamily: "'DM Sans', sans-serif", color: "rgba(255,255,255,0.38)", fontSize: "0.9rem" },
//     "& .MuiInputLabel-root.Mui-focused": { color: "rgba(30,144,255,0.9)" },
//     "& .MuiInputBase-input": { fontSize: "0.93rem" },
//     "& .MuiFormHelperText-root": { fontFamily: "'DM Sans', sans-serif", fontSize: "0.76rem" },
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={!loading ? onClose : undefined}
//       maxWidth="sm"
//       fullWidth
//       PaperProps={{ sx: { background: "transparent", boxShadow: "none", overflow: "visible" } }}
//       BackdropProps={{ sx: { backdropFilter: "blur(12px)", background: "rgba(0,0,0,0.72)" } }}
//       sx={{ "& .MuiDialog-container": { alignItems: "center" } }}
//     >
//       <AnimatePresence>
//         {open && (
//           <motion.div key="expert-panel" variants={panelVariants}
//                       initial="hidden" animate="visible" exit="exit"
//                       style={{ position: "relative" }}>
//             <Box sx={{
//               position: "absolute", inset: "-1px", borderRadius: "24px",
//               background: "linear-gradient(135deg, rgba(30,144,255,0.35) 0%, rgba(30,144,255,0.05) 60%, transparent 100%)",
//               zIndex: 0, pointerEvents: "none",
//             }} />
//             <DialogContent sx={{
//               position: "relative", zIndex: 1,
//               background: "linear-gradient(145deg, rgba(6,12,28,0.97) 0%, rgba(4,8,20,0.99) 100%)",
//               border: "1px solid rgba(30,144,255,0.18)", borderRadius: "24px",
//               p: { xs: "28px 20px", sm: "36px 32px" }, overflow: "hidden",
//             }}>
//               <Box sx={{ position: "absolute", top: -60, right: -60, width: 200, height: 200, borderRadius: "50%", background: "radial-gradient(circle, rgba(30,144,255,0.12) 0%, transparent 70%)", filter: "blur(30px)", pointerEvents: "none" }} />
//               <Box sx={{ position: "absolute", bottom: -40, left: -40, width: 160, height: 160, borderRadius: "50%", background: "radial-gradient(circle, rgba(30,144,255,0.07) 0%, transparent 70%)", filter: "blur(25px)", pointerEvents: "none" }} />

//               <IconButton onClick={onClose} disabled={loading} aria-label="Close dialog"
//                 sx={{ position: "absolute", top: 14, right: 14, color: "rgba(255,255,255,0.4)", width: 36, height: 36, border: "1px solid rgba(255,255,255,0.08)", borderRadius: "10px", transition: "all 0.2s", "&:hover": { color: "rgba(255,255,255,0.85)", background: "rgba(30,144,255,0.1)", borderColor: "rgba(30,144,255,0.3)" } }}>
//                 <CloseIcon />
//               </IconButton>

//               <Box sx={{ mb: { xs: 3, sm: 4 }, pr: 3 }}>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.8 }}>
//                   <Box sx={{ position: "relative", width: 8, height: 8, flexShrink: 0 }}>
//                     <Box component={motion.div} animate={{ scale: [1, 2.2], opacity: [0.7, 0] }} transition={{ duration: 1.8, repeat: Infinity, ease: "easeOut" }} sx={{ position: "absolute", inset: 0, borderRadius: "50%", background: "#1E90FF" }} />
//                     <Box sx={{ width: 8, height: 8, borderRadius: "50%", background: "#1E90FF", boxShadow: "0 0 10px rgba(30,144,255,0.9)" }} />
//                   </Box>
//                   <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.72rem", color: "rgba(30,144,255,0.82)", fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase" }}>Expert Connect</Typography>
//                 </Box>
//                 <Typography sx={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, fontSize: { xs: "1.55rem", sm: "1.9rem" }, color: "rgba(255,255,255,0.97)", letterSpacing: "-0.04em", lineHeight: 1.08, mb: 1 }}>Talk to Our Experts</Typography>
//                 <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontSize: { xs: "0.83rem", sm: "0.88rem" }, color: "rgba(255,255,255,0.38)", lineHeight: 1.7, maxWidth: "92%" }}>Share your requirements and our enterprise AI specialists will reach out within 24 hours.</Typography>
//               </Box>

//               <AnimatePresence mode="wait">
//                 {success ? (
//                   <motion.div key="success" initial={{ opacity: 0, scale: 0.92, y: 12 }} animate={{ opacity: 1, scale: 1, y: 0, transition: { duration: 0.45, ease: [0.22,1,0.36,1] } }} exit={{ opacity: 0 }}>
//                     <Box sx={{ textAlign: "center", py: { xs: 3, sm: 4 }, px: 2 }}>
//                       <Box component={motion.div} animate={{ scale: [0.8, 1.08, 1], opacity: [0, 1, 1] }} transition={{ duration: 0.55, ease: [0.22,1,0.36,1] }}
//                            sx={{ width: 68, height: 68, borderRadius: "50%", background: "rgba(30,144,255,0.1)", border: "1.5px solid rgba(30,144,255,0.4)", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2.5, boxShadow: "0 0 32px rgba(30,144,255,0.25)" }}>
//                         <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
//                           <motion.path d="M6 14.5L11.5 20L22 9" stroke="#1E90FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 0.5, delay: 0.2, ease: "easeOut" }} />
//                         </svg>
//                       </Box>
//                       <Typography sx={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700, fontSize: { xs: "1.2rem", sm: "1.4rem" }, color: "rgba(255,255,255,0.95)", letterSpacing: "-0.03em", mb: 1 }}>Request Received!</Typography>
//                       <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.88rem", color: "rgba(255,255,255,0.45)", lineHeight: 1.75 }}>Your request has been received.<br/>Our experts will contact you shortly.</Typography>
//                     </Box>
//                   </motion.div>
//                 ) : (
//                   <motion.div key="form" initial={{ opacity: 1 }} exit={{ opacity: 0, y: -8 }}>
//                     <Collapse in={!!apiError}>
//                       <Alert severity="error" sx={{ mb: 2.5, borderRadius: "10px", background: "rgba(255,60,60,0.08)", border: "1px solid rgba(255,60,60,0.2)", color: "rgba(255,120,120,0.95)", fontFamily: "'DM Sans', sans-serif", fontSize: "0.84rem", "& .MuiAlert-icon": { color: "rgba(255,100,100,0.9)" } }}>{apiError}</Alert>
//                     </Collapse>
//                     <Stack spacing={{ xs: 2, sm: 2.4 }}>
//                       <TextField name="name"    label="Full Name"    value={form.name}    onChange={handleChange} error={!!errors.name}    helperText={errors.name}    fullWidth disabled={loading} autoComplete="name"  sx={fieldSx} />
//                       <TextField name="email"   label="Work Email"   type="email" value={form.email}   onChange={handleChange} error={!!errors.email}   helperText={errors.email}   fullWidth disabled={loading} autoComplete="email" sx={fieldSx} />
//                       <TextField name="contact" label="Contact Number" type="tel" value={form.contact} onChange={handleChange} error={!!errors.contact} helperText={errors.contact} fullWidth disabled={loading} autoComplete="tel"   sx={fieldSx} />
//                       <TextField name="purpose" label="Purpose / What would you like to discuss?" value={form.purpose} onChange={handleChange} error={!!errors.purpose} helperText={errors.purpose} fullWidth multiline rows={3} disabled={loading} sx={fieldSx} />
//                     </Stack>
//                     <Button fullWidth variant="contained" onClick={handleSubmit} disabled={loading}
//                             component={motion.button} whileHover={!loading ? { scale: 1.015 } : {}} whileTap={!loading ? { scale: 0.985 } : {}}
//                             sx={{ mt: { xs: 3, sm: 3.5 }, py: 1.65, borderRadius: "13px", textTransform: "none", fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: "0.97rem", letterSpacing: "0.01em", background: "linear-gradient(135deg, #1565C0 0%, #1E90FF 100%)", boxShadow: "0 4px 24px rgba(30,144,255,0.35)", transition: "box-shadow 0.22s ease", "&:hover": { background: "linear-gradient(135deg, #1976D2 0%, #42A5F5 100%)", boxShadow: "0 6px 32px rgba(30,144,255,0.5)" }, "&.Mui-disabled": { background: "rgba(30,144,255,0.25)", color: "rgba(255,255,255,0.4)" } }}>
//                       {loading ? (
//                         <Stack direction="row" alignItems="center" spacing={1.2}>
//                           <CircularProgress size={17} sx={{ color: "rgba(255,255,255,0.6)" }} />
//                           <span>Submitting…</span>
//                         </Stack>
//                       ) : "Connect with an Expert →"}
//                     </Button>
//                     <Typography sx={{ mt: 1.8, textAlign: "center", fontFamily: "'DM Sans', sans-serif", fontSize: "0.74rem", color: "rgba(255,255,255,0.22)" }}>We respect your privacy. No spam, ever.</Typography>
//                   </motion.div>
//                 )}
//               </AnimatePresence>
//             </DialogContent>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </Dialog>
//   );
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // ENTERPRISE HERO
// // ─────────────────────────────────────────────────────────────────────────────
// export default function EnterpriseHero() {
//   const [wordIndex,  setWordIndex]  = useState(0);
//   const [dialogOpen, setDialogOpen] = useState(false);
//    const handleViewCapabilities = () => {
//     const section = document.getElementById("our-solutions");

//     if (section) {
//       section.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }
//   };

//   useEffect(() => {
//     const id = setInterval(() => setWordIndex((i) => (i + 1) % WORDS.length), WORD_INTERVAL);
//     return () => clearInterval(id);
//   }, []);

//   return (
//     <>
//       <Styles />
//       <Header1 />

//       <TalkToExpertsDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />

//       <Box
//         component="section"
//         className="hero-shell"
//         sx={{
//           position: "relative",
//           // Use dvh for better mobile browser chrome handling; fall back to svh then vh
          
//           boxSizing: "border-box",
//           overflowX: "hidden",
//            overflowY: "hidden",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
         
//           backgroundColor: "#000000",
//           color: "#ffffff",
//           fontFamily: "'Bricolage Grotesque', sans-serif",
//         }}
//       >
//         <NeuralBackground />
//         <AmbientGlow />
//         <ScanLines />
//         <ParticleField />

//         {/* Grid overlay */}
//         <Box aria-hidden sx={{
//           position: "absolute", inset: 0,
//           backgroundImage:
//             "linear-gradient(rgba(255,255,255,0.018) 1px, transparent 1px)," +
//             "linear-gradient(90deg, rgba(255,255,255,0.018) 1px, transparent 1px)",
//           backgroundSize: { xs: "44px 44px", sm: "54px 54px", md: "64px 64px" },
//           maskImage: "radial-gradient(ellipse 62% 62% at 50% 48%, black, transparent)",
//           pointerEvents: "none",
//           zIndex: 2,
//         }} />

//         {/* ══════════════════════════ CONTENT ══════════════════════════ */}
//         <Container
//           maxWidth="xl"
//           sx={{
//             position: "relative",
//             zIndex: 10,
//             // Symmetric horizontal padding that breathes on every breakpoint
//             px: { xs: "18px", sm: "28px", md: "48px", lg: "64px", xl: "80px" },
//             // Vertical padding: gives room on small screens; centre-aligns on large
//             py: { xs: "40px", sm: "50px", md: "40px", lg: "60px", xl: "80px" },
//             // Constrain max width so text never stretches absurdly wide
//             maxWidth: { xl: "1400px" },
//           }}
//         >
//           <Box
//             sx={{
//               // Caps readable content width; centres on all screens
//               maxWidth: { xs: "100%", sm: "660px", md: "820px", lg: "960px", xl: "1060px" },
//               mx: "auto",
//               textAlign: "center",
//               // Prevent any child from bleeding outside
//               overflowX: "hidden",
//             }}
//           >

//             {/* ── Badge pill ── */}
//             <motion.div {...fadeUp(0.1)}>
//               <Box
//                 sx={{
//                   display: "inline-flex",
//                   alignItems: "center",
//                   // Gap scales with screen
//                   gap: { xs: "6px", sm: "8px", md: "10px" },
//                   px: { xs: "12px", sm: "16px", md: "18px" },
//                   py: { xs: "6px",  sm: "7px",  md: "8px"  },
//                   mb: { xs: "28px", sm: "36px", md: "48px", lg: "52px" },
//                   borderRadius: "999px",
//                   background: "rgba(30,144,255,0.06)",
//                   border: "1px solid rgba(30,144,255,0.22)",
//                   backdropFilter: "blur(16px)",
//                   // Let the pill centre properly without overflowing on 320 px screens
//                   width: "fit-content",
//                   maxWidth: "calc(100% - 8px)",
//                   mx: "auto",
//                   // Wrap gracefully at very small widths
//                   flexWrap: "wrap",
//                   justifyContent: "center",
//                   rowGap: "4px",
//                 }}
//               >
//                 <Box sx={{ position: "relative", width: 8, height: 8, flexShrink: 0 }}>
//                   <Box component={motion.div}
//                        animate={{ scale: [1, 2.4], opacity: [0.7, 0] }}
//                        transition={{ duration: 1.8, repeat: Infinity, ease: "easeOut" }}
//                        sx={{ position: "absolute", inset: 0, borderRadius: "50%", background: "#1E90FF" }} />
//                   <Box sx={{ width: 8, height: 8, borderRadius: "50%", background: "#1E90FF", boxShadow: "0 0 12px rgba(30,144,255,0.8)" }} />
//                 </Box>
//                 <Typography
//                   sx={{
//                     fontFamily: "'DM Sans', sans-serif",
//                     // clamp: scales from 10px on tiny screens → 13px on wide
//                     fontSize: "clamp(0.62rem, 1.6vw, 0.82rem)",
//                     color: "rgba(255,255,255,0.62)",
//                     fontWeight: 500,
//                     letterSpacing: "0.02em",
//                     lineHeight: 1.5,
//                     // Allow wrapping on very small screens instead of overflowing
//                     whiteSpace: { xs: "normal", sm: "nowrap" },
//                     textAlign: "center",
//                   }}
//                 >
//                   Enterprise AI&nbsp;·&nbsp;Agentic Systems&nbsp;·&nbsp;Real‑Time Intelligence
//                 </Typography>
//               </Box>
//             </motion.div>

//             {/* ── H1 headline ── */}
//             <motion.div {...fadeUp(0.22)}>
//               <Typography
//                 component="h1"
//                 sx={{
//                   fontFamily: "'Bricolage Grotesque', sans-serif",
//                   fontWeight: 800,
//                   // clamp tracks viewport width smoothly; no abrupt jumps at breakpoints
//                   fontSize: "clamp(2.2rem, 6.5vw, 5.8rem)",
//                   letterSpacing: "clamp(-1.6px, -0.06em, -3.8px)",
//                   lineHeight: { xs: 1.04, sm: 1.05, md: 1.03, lg: 1.02 },
//                   color: "rgba(255,255,255,0.97)",
//                   // Prevent single long word from busting the container
//                   wordBreak: "break-word",
//                   overflowWrap: "break-word",
//                   px: { xs: 0, sm: 0 },
//                 }}
//               >
//                 Building Enterprise AI
//                 <br />
//                 <Box component="span" sx={{ color: "#1E90FF" }}>
//                   For Real‑World
//                 </Box>
//               </Typography>
//             </motion.div>

//             {/* ── Rotating word ── */}
//             <motion.div {...fadeUp(0.28)}>
//               <Box
//                 sx={{
//                   mt: { xs: "6px", md: "4px" },
//                   // Height tracks font-size so the animated text is never clipped
//                   height: "clamp(46px, 7.5vw, 100px)",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   // overflow visible so descenders/ascenders aren't cut
//                   overflow: "visible",
//                   position: "relative",
//                   // Small horizontal padding prevents blurred text from bleeding into screen edge
//                   px: { xs: "12px", sm: 0 },
//                 }}
//               >
//                 <AnimatePresence mode="wait">
//                   <motion.span
//                     key={wordIndex}
//                     variants={wordVariants}
//                     initial="enter"
//                     animate="visible"
//                     exit="exit"
//                     style={{
//                       position: "absolute",
//                       display: "block",
//                       fontFamily: "'Bricolage Grotesque', sans-serif",
//                       fontWeight: 800,
//                       // clamp matches h1 size exactly so the two lines feel unified
//                       fontSize: "clamp(2.2rem, 6.5vw, 5.8rem)",
//                       letterSpacing: "clamp(-1.6px, -0.06em, -3.8px)",
//                       lineHeight: 1,
//                       color: "#1E90FF",
//                       // Never overflow; scale with viewport
//                       whiteSpace: "nowrap",
//                       maxWidth: "100vw",
//                     }}
//                   >
//                     {WORDS[wordIndex]}
//                   </motion.span>
//                 </AnimatePresence>
//               </Box>
//             </motion.div>

//             {/* ── Subtitle ── */}
//             <motion.div {...fadeUp(0.38)}>
//               <Typography
//                 sx={{
//                   fontFamily: "'DM Sans', sans-serif",
//                   mt: { xs: "28px", sm: "32px", md: "40px", lg: "44px" },
//                   mx: "auto",
//                   maxWidth: { xs: "100%", sm: "520px", md: "640px", lg: "720px", xl: "780px" },
//                   fontSize: "clamp(0.88rem, 1.4vw, 1.08rem)",
//                   lineHeight: { xs: 1.78, md: 1.88 },
//                   color: "rgba(255,255,255,0.48)",
//                   fontWeight: 400,
//                   // No horizontal padding needed; the maxWidth handles alignment
//                   px: 0,
//                 }}
//               >
//                 From sovereign AI infrastructure and multilingual LLM systems to
//                 voice agents, RAG architectures, multimodal AI, and real‑time enterprise
//                 automation — we design intelligent systems built for scale, security,
//                 and real‑world deployment.
//               </Typography>
//             </motion.div> 

//             {/* ── CTA Buttons ── */}
//              <motion.div {...fadeUp(0.5)}>
//               <Stack
//                 direction={{ xs: "column", sm: "row" }}
//                 spacing={{ xs: "12px", sm: "14px", md: "16px" }}
//                 justifyContent="center"
//                 alignItems={{ xs: "stretch", sm: "center" }}
//                 sx={{
//                   mt: { xs: "36px", sm: "40px", md: "52px", lg: "56px" },
//                   width: "100%",
//                   px: { xs: 0, sm: 0 },
//                 }}
//               >
//                 <Button
//                   variant="contained"
//                   size="large"
//                   onClick={() => setDialogOpen(true)}
//                   component={motion.button}
//                   whileHover={{ scale: 1.03 }}
//                   whileTap={{ scale: 0.97 }}
//                   sx={{
//                     px: { xs: "28px", md: "36px" },
//                     py: { xs: "13px", md: "14px" },
//                     borderRadius: "13px",
//                     textTransform: "none",
//                     fontFamily: "'DM Sans', sans-serif",
//                     fontWeight: 600,
//                     fontSize: "clamp(0.88rem, 1.2vw, 0.98rem)",
//                     letterSpacing: "0.01em",
//                     // Full width on xs so both buttons align; auto on sm+
//                     width: { xs: "100%", sm: "auto" },
//                     minWidth: { sm: "168px" },
//                     maxWidth: { xs: "100%", sm: "300px" },
//                     alignSelf: { xs: "stretch", sm: "center" },
//                   }}
//                 >
//                   Talk to Experts
//                 </Button>

//                 <Button
//                   variant="outlined"
//                   size="large"
//                   onClick={handleViewCapabilities}
//                   component={motion.button}
//                   whileHover={{ scale: 1.03 }}
//                   whileTap={{ scale: 0.97 }}
//                   sx={{
//                     px: { xs: "28px", md: "36px" },
//                     py: { xs: "13px", md: "14px" },
//                     borderRadius: "13px",
//                     textTransform: "none",
//                     fontFamily: "'DM Sans', sans-serif",
//                     fontWeight: 600,
//                     fontSize: "clamp(0.88rem, 1.2vw, 0.98rem)",
//                     letterSpacing: "0.01em",
//                     border: "1px solid rgba(255,255,255,0.12)",
//                     color: "rgba(255,255,255,0.82)",
//                     background: "rgba(255,255,255,0.03)",
//                     backdropFilter: "blur(14px)",
//                     transition: "border-color 0.22s ease, background 0.22s ease, color 0.22s ease",
//                     width: { xs: "100%", sm: "auto" },
//                     minWidth: { sm: "168px" },
//                     maxWidth: { xs: "100%", sm: "300px" },
//                     alignSelf: { xs: "stretch", sm: "center" },
//                     "&:hover": {
//                       border: "1px solid rgba(30,144,255,0.45)",
//                       background: "rgba(30,144,255,0.07)",
//                       color: "#ffffff",
//                     },
//                   }}
//                 >
//                   View Capabilities
//                 </Button>
//               </Stack>
//             </motion.div> 

//             {/* ── Stats tiles ── */}
//              <motion.div {...fadeUp(0.62)}>
//               <Stack
//                 direction={{ xs: "column", sm: "row" }}
//                 spacing={{ xs: "14px", sm: "16px", md: "20px", lg: "24px" }}
//                 justifyContent="center"
//                 alignItems={{ xs: "stretch", sm: "stretch" }}
//                 sx={{
//                   mt: { xs: "44px", sm: "52px", md: "72px", lg: "80px" },
//                   width: "100%",
//                   // On sm+ allow cards to fill equal share up to a sensible max
//                   "& > *": {
//                     flex: { sm: "1 1 0" },
//                     maxWidth: { sm: "220px", md: "240px", lg: "260px", xl: "280px" },
//                     minWidth: { sm: "150px" },
//                   },
//                 }}
//               >
//                 {[

//                    { end: 40, suffix: "+", label: "AI Solutions Built" },
//                   { end: 35, suffix: "+", label: "Foundation Models Integrated"    },
//                   { end: 20, suffix: "+", label: "Languages Supported"   },
//                 ].map((item, i) => (
//                   <Box
//                     key={item.label}
//                     component={motion.div}
//                     initial={{ opacity: 0, y: 28 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ duration: 0.6, delay: 0.65 + i * 0.11, ease: [0.22, 1, 0.36, 1] }}
//                     whileHover={{ y: -6, transition: { duration: 0.2 } }}
//                     sx={{
//                       position: "relative",
//                       overflow: "hidden",
//                       // Full width on xs; flex child on sm+
//                       width: { xs: "100%", sm: "auto" },
//                       px: { xs: "20px", sm: "22px", md: "28px", lg: "32px" },
//                       py: { xs: "20px", sm: "22px", md: "26px", lg: "28px" },
//                       borderRadius: { xs: "16px", md: "20px" },
//                       background: "rgba(255,255,255,0.03)",
//                       border: "1px solid rgba(255,255,255,0.07)",
//                       backdropFilter: "blur(24px)",
//                       boxShadow: "0 8px 40px rgba(0,0,0,0.4)",
//                       textAlign: "center",
//                     }}
//                   >
                  
//                     <Box sx={{
//                       position: "absolute", width: 110, height: 110, borderRadius: "50%",
//                       background: "radial-gradient(circle, rgba(30,144,255,0.1), transparent 70%)",
//                       top: -42, right: -32, filter: "blur(18px)", pointerEvents: "none",
//                       animation: `cardGlow ${5 + i * 1.5}s ease-in-out infinite`,
//                       animationDelay: `${-i * 1.8}s`,
//                     }} />
//                     <Typography sx={{
//                       position: "relative", zIndex: 1,
//                       fontFamily: "'Bricolage Grotesque', sans-serif",
//                       fontWeight: 800,
                     
//                       fontSize: "clamp(2rem, 3.5vw, 2.8rem)",
//                       lineHeight: 1,
//                       color: "#ffffff",
//                       letterSpacing: "-1px",
//                       mb: { xs: "6px", md: "8px" },
//                     }}>
//                       <Counter end={item.end} suffix={item.suffix} />
//                     </Typography>
//                     <Typography sx={{
//                       position: "relative", zIndex: 1,
//                       fontFamily: "'DM Sans', sans-serif",
//                       fontSize: "clamp(0.68rem, 1vw, 0.82rem)",
//                       color: "rgba(255,255,255,0.42)",
//                       letterSpacing: "0.06em",
//                       textTransform: "uppercase",
//                       fontWeight: 500,
//                       lineHeight: 1.55,
//                     }}>
//                       {item.label}
//                     </Typography>
//                   </Box>
//                 ))}
//               </Stack>
//             </motion.div> 

//           </Box>
//         </Container>

//         {/* Bottom vignette */}
//         <Box aria-hidden sx={{
//           position: "absolute", bottom: 0, left: 0, right: 0,
//           height: { xs: "120px", md: "200px" },
//           background: "linear-gradient(to top, #000000 0%, transparent 100%)",
//           pointerEvents: "none",
//           zIndex: 5,
//         }} />
//       </Box>

//       <TrustedBy />
//       <div id="our-solutions">
//   <OurSolutions />
// </div>
//       <IndustriesSlider />
//       <RecognizedBy />
//       <HomeBlogSection />
//       <RequestAuditSection />
//       <NewsLetterSection />
//       <Footer />
//     </>
//   );
// }


import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Stack,
  Typography,
  Dialog,
  DialogContent,
  TextField,
  IconButton,
  CircularProgress,
  Alert,
  Collapse,
} from "@mui/material";
import EnterpriseHeroV2 from "../Enterprise/Enterpriseherov2";


import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";

import Header1            from "../Header/Header1";
import TrustedBy          from "./TrustedBy";
import IndustriesSlider   from "./IndustriesSlider";
import OurSolutions       from "./OurSolutions";
import Footer             from "../Footer/Footer";
import NewsLetterSection  from "./NewsLetterSection";
import RecognizedBy       from "./RecognisedBy";
import HomeBlogSection    from "./HomeBlogSection";
import RequestAuditSection from "./Audit";

// ─────────────────────────────────────────────────────────────────────────────
// CONFIG
// ─────────────────────────────────────────────────────────────────────────────
const API_URL       = process.env.REACT_APP_API_URL || "";
const WORDS         = ["Voice Agents", "Multilingual AI", "RAG Systems"];
const WORD_INTERVAL = 3000;

const rng = (s) => { const x = Math.sin(s + 1) * 10000; return x - Math.floor(x); };

const PARTICLES = Array.from({ length: 55 }, (_, i) => ({
  id:      i,
  x:       rng(i * 3.14159) * 100,
  y:       rng(i * 2.71828) * 100,
  size:    rng(i * 1.41421) * 2.4 + 0.7,
  opacity: rng(i * 1.61803) * 0.18 + 0.04,
  durY:    rng(i * 5.55)    * 20  + 14,
  durX:    rng(i * 7.77)    * 16  + 10,
  dy:     (rng(i * 4.44)   - 0.5) * 50,
  dx:     (rng(i * 6.66)   - 0.5) * 30,
  isBlue:  rng(i * 9.99)    > 0.48,
  dlyY:    rng(i * 2.22)   * -25,
  dlyX:    rng(i * 3.33)   * -18,
}));

const NEURAL_PATHS = [
  { d: "M-200 155 C50 85  280 225 530 155 T980  155 T1430 155 T1950 155",   sw: 0.55, dur: 26, dly: 0    },
  { d: "M-200 455 C120 375 380 535 680 455 T1130 455 T1580 455 T1950 455",  sw: 0.70, dur: 32, dly: -10  },
  { d: "M-200 760 C80  688 310 832 580 760 T1030 760 T1480 760 T1950 760",  sw: 0.50, dur: 21, dly: -17  },
  { d: "M-80  0   C120 200 300 480 440 680 S560  850 590  1000",             sw: 0.55, dur: 28, dly: -5   },
  { d: "M1940 0   C1740 200 1560 480 1420 680 S1300 850 1270 1000",         sw: 0.55, dur: 28, dly: -14  },
  { d: "M-80  1000 C210 780 460 480 660 280 S810  80  900 -60",             sw: 0.50, dur: 23, dly: -9   },
  { d: "M390  -60 C368 170 438 380 470 545 S478 725 428 910",               sw: 0.50, dur: 19, dly: -7   },
  { d: "M970  -60 C948 200 1008 425 985 585 S965 765 1028 960",             sw: 0.50, dur: 24, dly: -12  },
  { d: "M1490 -60 C1468 155 1530 365 1506 528 S1486 708 1548 905",          sw: 0.48, dur: 22, dly: -18  },
  { d: "M140  315 C275 215 478 215 608 315 S738  415 690 500",              sw: 0.60, dur: 17, dly: -4   },
  { d: "M1010 215 C1130 115 1330 115 1450 215 S1570 315 1528 418",          sw: 0.60, dur: 18, dly: -11  },
  { d: "M440  558 C598 458 798 638 1000 558 S1202 458 1360 558",            sw: 0.55, dur: 22, dly: -15  },
];

const SIGNAL_PATHS = [
  { idx: 1,  dur: 10, dly: 0,  rev: false },
  { idx: 4,  dur: 13, dly: -4, rev: true  },
  { idx: 9,  dur:  9, dly: -2, rev: false },
  { idx: 11, dur: 12, dly: -7, rev: true  },
];

const NEURAL_NODES = [
  { cx: 530,  cy: 155, r: 2.2 }, { cx: 980,  cy: 155, r: 1.8 },
  { cx: 680,  cy: 455, r: 2.6 }, { cx: 1130, cy: 455, r: 2.0 },
  { cx: 390,  cy: 545, r: 1.8 }, { cx: 800,  cy: 680, r: 2.2 },
  { cx: 1200, cy: 295, r: 1.8 }, { cx: 340,  cy: 275, r: 2.0 },
  { cx: 1410, cy: 578, r: 2.2 }, { cx: 605,  cy: 760, r: 1.8 },
  { cx: 1058, cy: 760, r: 2.0 }, { cx: 195,  cy: 598, r: 1.8 },
];

// ─────────────────────────────────────────────────────────────────────────────
// GLOBAL STYLES
// ─────────────────────────────────────────────────────────────────────────────
const Styles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,400;12..96,600;12..96,750;12..96,800&family=DM+Sans:wght@300;400;500;600&display=swap');

    @keyframes neuralPulse {
      0%,100% { opacity: var(--np, .08); }
      50%     { opacity: calc(var(--np, .08) * 2.1); }
    }
    @keyframes signalFwd { from { stroke-dashoffset:  2700; } to { stroke-dashoffset: -2700; } }
    @keyframes signalRev { from { stroke-dashoffset: -2700; } to { stroke-dashoffset:  2700; } }
    @keyframes scanUp {
      0%   { transform: translateY(102vh); opacity: 0;   }
      4%   { opacity: 1;   }
      94%  { opacity: 0.7; }
      100% { transform: translateY(-4px);  opacity: 0;   }
    }
    @keyframes cardGlow {
      0%,100% { opacity: .5; transform: scale(1);    }
      50%     { opacity: .9; transform: scale(1.12); }
    }
    .np { animation: neuralPulse 8s ease-in-out infinite; }

    /*
     * ROOT FIX: hero-shell height must account for Header1's 64px in-flow spacer.
     *
     * Header1 renders TWO things:
     *   1. A position:fixed header bar  (out of flow — doesn't affect document height)
     *   2. A <Box height:"64px"> spacer (IN normal flow — adds to document height)
     *
     * The spacer is necessary on all other pages so content isn't hidden behind
     * the fixed bar. But on a full-viewport hero, it causes:
     *   document height = 64px spacer + 100svh hero = always overflows viewport
     *
     * Fix: subtract 64px from the hero height with calc().
     * The body-lock useEffect below is still kept as a secondary safeguard
     * against animation-phase sub-pixel rounding, but this calc() is the
     * primary fix that eliminates the structural overflow entirely.
     *
     * Progressive enhancement:
     *   100vh  → baseline (all browsers)
     *   100svh → small viewport height (mobile-safe, excludes dynamic chrome)
     *   100dvh → dynamic viewport height (preferred: adjusts as chrome shows/hides)
     *
     * IMPORTANT: If the Header1 spacer height ever changes from 64px,
     * update the calc() value here to match.
     */
    .hero-shell {
      height: calc(100vh - 64px);
      height: calc(100svh - 64px);
    }
    @supports (height: 100dvh) {
      .hero-shell {
        height: calc(100dvh - 64px);
      }
    }

    /*
     * Body lock during the animation phase.
     * Removed after 1400ms via JS (covers longest animation: delay 0.65s + duration 0.6s = 1.25s + buffer).
     * This is the belt to go with the height:100dvh suspenders.
     */
    body.hero-loading {
      overflow: hidden;
    }

    /* Dialog field styles */
    .expert-field .MuiOutlinedInput-root {
      background: rgba(255,255,255,0.04);
      border-radius: 12px;
      font-family: 'DM Sans', sans-serif;
      color: rgba(255,255,255,0.88);
      transition: background 0.2s;
    }
    .expert-field .MuiOutlinedInput-root:hover { background: rgba(30,144,255,0.05); }
    .expert-field .MuiOutlinedInput-root.Mui-focused { background: rgba(30,144,255,0.07); }
    .expert-field .MuiOutlinedInput-notchedOutline { border-color: rgba(255,255,255,0.1) !important; transition: border-color 0.2s; }
    .expert-field .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline { border-color: rgba(30,144,255,0.35) !important; }
    .expert-field .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline { border-color: rgba(30,144,255,0.7) !important; border-width: 1.5px !important; }
    .expert-field .MuiInputLabel-root { font-family: 'DM Sans', sans-serif; color: rgba(255,255,255,0.38); font-size: 0.9rem; }
    .expert-field .MuiInputLabel-root.Mui-focused { color: rgba(30,144,255,0.9); }
    .expert-field .MuiInputBase-input { font-size: 0.93rem; }
    .expert-field .MuiFormHelperText-root { font-family: 'DM Sans', sans-serif; font-size: 0.76rem; color: rgba(255,80,80,0.85); }

    /* Short viewport adjustments — hide non-essential sections on very short screens */
    @media (max-height: 780px) {
      .hero-badge    { margin-bottom: 16px !important; }
      .hero-subtitle { margin-top: 14px !important; }
      .hero-cta      { margin-top: 20px !important; }
      .hero-stats    { margin-top: 20px !important; }
      .hero-stats > div { padding-top: 12px !important; padding-bottom: 12px !important; }
    }
    @media (max-height: 640px) {
      .hero-subtitle { display: none !important; }
      .hero-stats    { margin-top: 16px !important; }
    }
    @media (max-height: 520px) {
      .hero-stats { display: none !important; }
    }
  `}</style>
);

// ─────────────────────────────────────────────────────────────────────────────
// MOTION HELPERS
// ─────────────────────────────────────────────────────────────────────────────
const wordVariants = {
  enter:   { opacity: 0, y: 18,  filter: "blur(7px)"  },
  visible: { opacity: 1, y: 0,   filter: "blur(0px)",
             transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } },
  exit:    { opacity: 0, y: -14, filter: "blur(4px)",
             transition: { duration: 0.38, ease: [0.55, 0, 0.78, 0] } },
};

// Reduced y offset from 26 → 16 to shrink the layout footprint during animation
const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0,
             transition: { duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] } },
});

// ─────────────────────────────────────────────────────────────────────────────
// BACKGROUND COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────
const NeuralBackground = () => (
  <Box aria-hidden sx={{ position: "absolute", inset: 0, overflow: "hidden", pointerEvents: "none", zIndex: 0 }}>
    <svg viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid slice"
         style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}>
      {NEURAL_PATHS.map((p, i) => (
        <path key={`base-${i}`} className="np" d={p.d} fill="none"
              stroke="rgba(30,144,255,1)" strokeWidth={p.sw}
              style={{ "--np": 0.07 + (i % 3) * 0.02, animationDuration: `${p.dur}s`, animationDelay: `${p.dly}s` }} />
      ))}
      {SIGNAL_PATHS.map((sp, i) => (
        <path key={`sig-${i}`} d={NEURAL_PATHS[sp.idx].d} fill="none"
              stroke="rgba(96,165,250,0.55)" strokeWidth="1.4" strokeLinecap="round"
              strokeDasharray="65 2700"
              style={{ animation: `${sp.rev ? "signalRev" : "signalFwd"} ${sp.dur}s linear infinite`, animationDelay: `${sp.dly}s` }} />
      ))}
      {NEURAL_NODES.map((n, i) => (
        <motion.circle key={`node-${i}`} cx={n.cx} cy={n.cy}
                       fill="rgba(30,144,255,0.25)" stroke="rgba(96,165,250,0.3)" strokeWidth="0.8"
                       animate={{ r: [n.r, n.r + 2.8, n.r], opacity: [0.22, 0.52, 0.22] }}
                       transition={{ duration: 3.2 + i * 0.35, repeat: Infinity, ease: "easeInOut", delay: -(i * 0.42) }} />
      ))}
    </svg>
  </Box>
);

const AmbientGlow = () => (
  // Absolutely positioned inside .hero-shell — clipped by overflow:hidden once hero has fixed height
  <Box aria-hidden sx={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 0 }}>
    <Box component={motion.div}
         animate={{ scale: [1, 1.18, 1], opacity: [0.45, 0.75, 0.45] }}
         transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
         sx={{ position: "absolute", top: "-18%", right: "-12%",
               width: { xs: 280, sm: 380, md: 580, xl: 700 },
               height: { xs: 280, sm: 380, md: 580, xl: 700 },
               borderRadius: "50%",
               background: "radial-gradient(circle, rgba(30,144,255,0.11) 0%, transparent 70%)",
               filter: "blur(45px)" }} />
    <Box component={motion.div}
         animate={{ scale: [1, 1.12, 1], opacity: [0.35, 0.6, 0.35] }}
         transition={{ duration: 11, repeat: Infinity, ease: "easeInOut", delay: -3.5 }}
         sx={{ position: "absolute", bottom: "-22%", left: "-12%",
               width: { xs: 220, sm: 320, md: 480, xl: 580 },
               height: { xs: 220, sm: 320, md: 480, xl: 580 },
               borderRadius: "50%",
               background: "radial-gradient(circle, rgba(30,144,255,0.08) 0%, transparent 70%)",
               filter: "blur(60px)" }} />
    <Box component={motion.div}
         animate={{ opacity: [0.12, 0.24, 0.12] }}
         transition={{ duration: 7, repeat: Infinity, ease: "easeInOut", delay: -2 }}
         sx={{ position: "absolute", top: "15%", left: "50%", transform: "translateX(-50%)",
               width: { xs: 340, sm: 520, md: 820, xl: 1100 },
               height: { xs: 140, sm: 220, md: 320, xl: 400 },
               borderRadius: "50%",
               background: "radial-gradient(ellipse, rgba(30,144,255,0.07) 0%, transparent 70%)",
               filter: "blur(55px)" }} />
  </Box>
);

const ScanLines = () => (
  <Box aria-hidden sx={{ position: "absolute", inset: 0, overflow: "hidden", pointerEvents: "none", zIndex: 1 }}>
    {[{ op: 0.055, dur: 24, dly: 0 }, { op: 0.04, dur: 30, dly: -9 }, { op: 0.03, dur: 38, dly: -18 }]
      .map((s, i) => (
        <Box key={i} sx={{
          position: "absolute", left: 0, right: 0, height: "1px",
          background: `linear-gradient(90deg, transparent 0%, rgba(30,144,255,${s.op * 2}) 20%, rgba(96,165,250,${s.op}) 50%, rgba(30,144,255,${s.op * 2}) 80%, transparent 100%)`,
          animation: `scanUp ${s.dur}s linear infinite`,
          animationDelay: `${s.dly}s`,
        }} />
      ))}
  </Box>
);

const ParticleField = () => (
  <Box aria-hidden sx={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 1, overflow: "hidden" }}>
    {PARTICLES.map((p) => (
      <Box key={p.id} component={motion.div}
           animate={{ y: [0, p.dy, 0], x: [0, p.dx, 0] }}
           transition={{
             y: { duration: p.durY, repeat: Infinity, ease: "easeInOut", delay: p.dlyY },
             x: { duration: p.durX, repeat: Infinity, ease: "easeInOut", delay: p.dlyX },
           }}
           sx={{
             position: "absolute", left: `${p.x}%`, top: `${p.y}%`,
             width: `${p.size}px`, height: `${p.size}px`, borderRadius: "50%",
             background: p.isBlue ? `rgba(30,144,255,${p.opacity * 3})` : `rgba(255,255,255,${p.opacity})`,
             boxShadow: p.isBlue && p.size > 2 ? `0 0 ${p.size * 3}px rgba(30,144,255,0.5)` : "none",
             willChange: "transform",
           }} />
    ))}
  </Box>
);

// ─────────────────────────────────────────────────────────────────────────────
// COUNTER
// ─────────────────────────────────────────────────────────────────────────────
const Counter = ({ end, suffix = "+" }) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let cur = 0;
    const step = end / (1800 / 16);
    const timer = setInterval(() => {
      cur += step;
      if (cur >= end) { setCount(end); clearInterval(timer); }
      else setCount(Math.floor(cur));
    }, 16);
    return () => clearInterval(timer);
  }, [end]);
  return <>{count}{suffix}</>;
};

// ─────────────────────────────────────────────────────────────────────────────
// CLOSE ICON
// ─────────────────────────────────────────────────────────────────────────────
const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <line x1="1" y1="1" x2="17" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="17" y1="1" x2="1" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

// ─────────────────────────────────────────────────────────────────────────────
// TALK TO EXPERTS DIALOG
// ─────────────────────────────────────────────────────────────────────────────
const INITIAL_FORM   = { name: "", email: "", contact: "", purpose: "" };
const INITIAL_ERRORS = { name: "", email: "", contact: "", purpose: "" };

function TalkToExpertsDialog({ open, onClose }) {
  const [form,     setForm]     = useState(INITIAL_FORM);
  const [errors,   setErrors]   = useState(INITIAL_ERRORS);
  const [loading,  setLoading]  = useState(false);
  const [success,  setSuccess]  = useState(false);
  const [apiError, setApiError] = useState("");

  useEffect(() => {
    if (open) {
      setForm(INITIAL_FORM); setErrors(INITIAL_ERRORS);
      setLoading(false); setSuccess(false); setApiError("");
    }
  }, [open]);

  const validate = () => {
    const errs = { ...INITIAL_ERRORS }; let valid = true;
    if (!form.name.trim())                                          { errs.name    = "Name is required";              valid = false; }
    if (!form.email.trim())                                         { errs.email   = "Email is required";             valid = false; }
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))      { errs.email   = "Enter a valid email";            valid = false; }
    if (!form.contact.trim())                                       { errs.contact = "Contact number is required";   valid = false; }
    else if (!/^\+?[\d\s\-().]{7,20}$/.test(form.contact))        { errs.contact = "Enter a valid number";          valid = false; }
    if (!form.purpose.trim())                                       { errs.purpose = "Please describe your purpose"; valid = false; }
    setErrors(errs); return valid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    if (errors[name])  setErrors(prev  => ({ ...prev, [name]: "" }));
    if (apiError)      setApiError("");
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true); setApiError("");
    try {
      await axios.post(`${API_URL}/expert/contact/`, {
        name: form.name.trim(), email: form.email.trim(),
        contact: form.contact.trim(), purpose: form.purpose.trim(),
      });
      setSuccess(true);
      setTimeout(() => onClose(), 2800);
    } catch (err) {
      setApiError(
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        "Something went wrong. Please try again."
      );
    } finally { setLoading(false); }
  };

  const panelVariants = {
    hidden:  { opacity: 0, y: 40, scale: 0.96 },
    visible: { opacity: 1, y: 0,  scale: 1,    transition: { duration: 0.42, ease: [0.22, 1, 0.36, 1] } },
    exit:    { opacity: 0, y: 24, scale: 0.97, transition: { duration: 0.26, ease: [0.55, 0, 0.78, 0] } },
  };

  const fieldSx = {
    mb: 0,
    "& .MuiOutlinedInput-root": {
      background: "rgba(255,255,255,0.04)", borderRadius: "12px",
      fontFamily: "'DM Sans', sans-serif", color: "rgba(255,255,255,0.88)", transition: "background 0.2s",
      "&:hover": { background: "rgba(30,144,255,0.05)" },
      "&.Mui-focused": { background: "rgba(30,144,255,0.07)" },
    },
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,0.1)", transition: "border-color 0.2s" },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(30,144,255,0.35)" },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(30,144,255,0.7)", borderWidth: "1.5px" },
    "& .MuiInputLabel-root": { fontFamily: "'DM Sans', sans-serif", color: "rgba(255,255,255,0.38)", fontSize: "0.9rem" },
    "& .MuiInputLabel-root.Mui-focused": { color: "rgba(30,144,255,0.9)" },
    "& .MuiInputBase-input": { fontSize: "0.93rem" },
    "& .MuiFormHelperText-root": { fontFamily: "'DM Sans', sans-serif", fontSize: "0.76rem" },
  };

  return (
    <Dialog
      open={open}
      onClose={!loading ? onClose : undefined}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { background: "transparent", boxShadow: "none", overflow: "visible" } }}
      BackdropProps={{ sx: { backdropFilter: "blur(12px)", background: "rgba(0,0,0,0.72)" } }}
      sx={{ "& .MuiDialog-container": { alignItems: "center" } }}
    >
      <AnimatePresence>
        {open && (
          <motion.div key="expert-panel" variants={panelVariants}
                      initial="hidden" animate="visible" exit="exit"
                      style={{ position: "relative" }}>
            <Box sx={{
              position: "absolute", inset: "-1px", borderRadius: "24px",
              background: "linear-gradient(135deg, rgba(30,144,255,0.35) 0%, rgba(30,144,255,0.05) 60%, transparent 100%)",
              zIndex: 0, pointerEvents: "none",
            }} />
            <DialogContent sx={{
              position: "relative", zIndex: 1,
              background: "linear-gradient(145deg, rgba(6,12,28,0.97) 0%, rgba(4,8,20,0.99) 100%)",
              border: "1px solid rgba(30,144,255,0.18)", borderRadius: "24px",
              p: { xs: "28px 20px", sm: "36px 32px" }, overflow: "hidden",
            }}>
              <Box sx={{ position: "absolute", top: -60, right: -60, width: 200, height: 200, borderRadius: "50%", background: "radial-gradient(circle, rgba(30,144,255,0.12) 0%, transparent 70%)", filter: "blur(30px)", pointerEvents: "none" }} />
              <Box sx={{ position: "absolute", bottom: -40, left: -40, width: 160, height: 160, borderRadius: "50%", background: "radial-gradient(circle, rgba(30,144,255,0.07) 0%, transparent 70%)", filter: "blur(25px)", pointerEvents: "none" }} />

              <IconButton onClick={onClose} disabled={loading} aria-label="Close dialog"
                sx={{ position: "absolute", top: 14, right: 14, color: "rgba(255,255,255,0.4)", width: 36, height: 36, border: "1px solid rgba(255,255,255,0.08)", borderRadius: "10px", transition: "all 0.2s", "&:hover": { color: "rgba(255,255,255,0.85)", background: "rgba(30,144,255,0.1)", borderColor: "rgba(30,144,255,0.3)" } }}>
                <CloseIcon />
              </IconButton>

              <Box sx={{ mb: { xs: 3, sm: 4 }, pr: 3 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.8 }}>
                  <Box sx={{ position: "relative", width: 8, height: 8, flexShrink: 0 }}>
                    <Box component={motion.div} animate={{ scale: [1, 2.2], opacity: [0.7, 0] }} transition={{ duration: 1.8, repeat: Infinity, ease: "easeOut" }} sx={{ position: "absolute", inset: 0, borderRadius: "50%", background: "#1E90FF" }} />
                    <Box sx={{ width: 8, height: 8, borderRadius: "50%", background: "#1E90FF", boxShadow: "0 0 10px rgba(30,144,255,0.9)" }} />
                  </Box>
                  <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.72rem", color: "rgba(30,144,255,0.82)", fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase" }}>Expert Connect</Typography>
                </Box>
                <Typography sx={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, fontSize: { xs: "1.55rem", sm: "1.9rem" }, color: "rgba(255,255,255,0.97)", letterSpacing: "-0.04em", lineHeight: 1.08, mb: 1 }}>Talk to Our Experts</Typography>
                <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontSize: { xs: "0.83rem", sm: "0.88rem" }, color: "rgba(255,255,255,0.38)", lineHeight: 1.7, maxWidth: "92%" }}>Share your requirements and our enterprise AI specialists will reach out within 24 hours.</Typography>
              </Box>

              <AnimatePresence mode="wait">
                {success ? (
                  <motion.div key="success" initial={{ opacity: 0, scale: 0.92, y: 12 }} animate={{ opacity: 1, scale: 1, y: 0, transition: { duration: 0.45, ease: [0.22,1,0.36,1] } }} exit={{ opacity: 0 }}>
                    <Box sx={{ textAlign: "center", py: { xs: 3, sm: 4 }, px: 2 }}>
                      <Box component={motion.div} animate={{ scale: [0.8, 1.08, 1], opacity: [0, 1, 1] }} transition={{ duration: 0.55, ease: [0.22,1,0.36,1] }}
                           sx={{ width: 68, height: 68, borderRadius: "50%", background: "rgba(30,144,255,0.1)", border: "1.5px solid rgba(30,144,255,0.4)", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2.5, boxShadow: "0 0 32px rgba(30,144,255,0.25)" }}>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                          <motion.path d="M6 14.5L11.5 20L22 9" stroke="#1E90FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 0.5, delay: 0.2, ease: "easeOut" }} />
                        </svg>
                      </Box>
                      <Typography sx={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700, fontSize: { xs: "1.2rem", sm: "1.4rem" }, color: "rgba(255,255,255,0.95)", letterSpacing: "-0.03em", mb: 1 }}>Request Received!</Typography>
                      <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontSize: "0.88rem", color: "rgba(255,255,255,0.45)", lineHeight: 1.75 }}>Your request has been received.<br/>Our experts will contact you shortly.</Typography>
                    </Box>
                  </motion.div>
                ) : (
                  <motion.div key="form" initial={{ opacity: 1 }} exit={{ opacity: 0, y: -8 }}>
                    <Collapse in={!!apiError}>
                      <Alert severity="error" sx={{ mb: 2.5, borderRadius: "10px", background: "rgba(255,60,60,0.08)", border: "1px solid rgba(255,60,60,0.2)", color: "rgba(255,120,120,0.95)", fontFamily: "'DM Sans', sans-serif", fontSize: "0.84rem", "& .MuiAlert-icon": { color: "rgba(255,100,100,0.9)" } }}>{apiError}</Alert>
                    </Collapse>
                    <Stack spacing={{ xs: 2, sm: 2.4 }}>
                      <TextField name="name"    label="Full Name"    value={form.name}    onChange={handleChange} error={!!errors.name}    helperText={errors.name}    fullWidth disabled={loading} autoComplete="name"  sx={fieldSx} />
                      <TextField name="email"   label="Work Email"   type="email" value={form.email}   onChange={handleChange} error={!!errors.email}   helperText={errors.email}   fullWidth disabled={loading} autoComplete="email" sx={fieldSx} />
                      <TextField name="contact" label="Contact Number" type="tel" value={form.contact} onChange={handleChange} error={!!errors.contact} helperText={errors.contact} fullWidth disabled={loading} autoComplete="tel"   sx={fieldSx} />
                      <TextField name="purpose" label="Purpose / What would you like to discuss?" value={form.purpose} onChange={handleChange} error={!!errors.purpose} helperText={errors.purpose} fullWidth multiline rows={3} disabled={loading} sx={fieldSx} />
                    </Stack>
                    <Button fullWidth variant="contained" onClick={handleSubmit} disabled={loading}
                            component={motion.button} whileHover={!loading ? { scale: 1.015 } : {}} whileTap={!loading ? { scale: 0.985 } : {}}
                            sx={{ mt: { xs: 3, sm: 3.5 }, py: 1.65, borderRadius: "13px", textTransform: "none", fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: "0.97rem", letterSpacing: "0.01em", background: "linear-gradient(135deg, #1565C0 0%, #1E90FF 100%)", boxShadow: "0 4px 24px rgba(30,144,255,0.35)", transition: "box-shadow 0.22s ease", "&:hover": { background: "linear-gradient(135deg, #1976D2 0%, #42A5F5 100%)", boxShadow: "0 6px 32px rgba(30,144,255,0.5)" }, "&.Mui-disabled": { background: "rgba(30,144,255,0.25)", color: "rgba(255,255,255,0.4)" } }}>
                      {loading ? (
                        <Stack direction="row" alignItems="center" spacing={1.2}>
                          <CircularProgress size={17} sx={{ color: "rgba(255,255,255,0.6)" }} />
                          <span>Submitting…</span>
                        </Stack>
                      ) : "Connect with an Expert →"}
                    </Button>
                    <Typography sx={{ mt: 1.8, textAlign: "center", fontFamily: "'DM Sans', sans-serif", fontSize: "0.74rem", color: "rgba(255,255,255,0.22)" }}>We respect your privacy. No spam, ever.</Typography>
                  </motion.div>
                )}
              </AnimatePresence>
            </DialogContent>
          </motion.div>
        )}
      </AnimatePresence>
    </Dialog>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// ENTERPRISE HERO
// ─────────────────────────────────────────────────────────────────────────────
export default function EnterpriseHero() {
  const [wordIndex,  setWordIndex]  = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleViewCapabilities = () => {
    const section = document.getElementById("our-solutions");
    if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  useEffect(() => {
    const id = setInterval(() => setWordIndex((i) => (i + 1) % WORDS.length), WORD_INTERVAL);
    return () => clearInterval(id);
  }, []);

  /*
   * SCROLLBAR FLASH FIX — body lock (secondary safeguard only)
   *
   * The PRIMARY fix is height: calc(100svh - 64px) which eliminates the structural
   * overflow caused by Header1's 64px in-flow spacer sitting above the hero.
   *
   * This body lock handles the remaining animation-phase flash:
   * stats cards have initial y:16 + delay 0.60s, so they momentarily push content
   * slightly beyond the hero boundary. The lock covers ~1.1s animation settle + buffer.
   *
   * Cleanup on unmount removes hero-loading if user navigates away mid-load.
   */
  useEffect(() => {
    document.body.classList.add("hero-loading");
    const timer = setTimeout(() => {
      document.body.classList.remove("hero-loading");
    }, 1400);
    return () => {
      clearTimeout(timer);
      document.body.classList.remove("hero-loading");
    };
  }, []);

  return (
    <>
      <EnterpriseHeroV2 />

      <TrustedBy />
      <div id="our-solutions">
        <OurSolutions />
      </div>
      <IndustriesSlider />
      <RecognizedBy />
      <HomeBlogSection />
      <RequestAuditSection />
      <NewsLetterSection />
      <Footer />
    </>
  );
}